<template>
  <div v-show="position.show">
    <!-- <a-progress type="circle" :percent="textData" :width="80" strokeColor="#000" /> -->
    <!-- 不显示真实值 -->
    <div v-if="option.dataTrue === false" :style="backGroundColorStyle">
      <div style="margin:10px;">
        <div style="display:inline-block;text-align:left;float:left;" v-if="option.titleOption" :style="fontStyle">
          {{ option.title }}
        </div>
        <!-- <div style="display:inline-block;width:60%;"> -->
        <div style="display:inline-block;float:right;">
          <div
            v-if="option.pictureOption"
            style="
            display:inline-block;
            vertical-align:middle;
            border-radius:20px;
            width:20px;
            height:10px;
            background-color:#f5f5f5"
          ></div>
          <span :style="pictureFontsizeStyle" v-if="option.pictureOption"
            >{{ option.dataAllTitle }}：{{ optionDataAll }}{{ option.company | companyOption(option.dataTrue) }}</span
          >
        </div>
        <div style="display:inline-block;float:right;margin-right:2%;">
          <div
            v-if="option.pictureOption"
            style="
            display:inline-block;
            vertical-align:middle;
            border-radius:20px;
            width:20px;
            height:10px;"
            :style="progressColor"
          ></div>
          <span :style="pictureFontsizeStyle" v-if="option.pictureOption"
            >{{ option.dataTitle }}：{{ optionData }}{{ option.company | companyOption(option.dataTrue) }}</span
          >
        </div>
        <!-- </div> -->
      </div>
      <a-progress
        style="margin-top:10px;"
        :showInfo="false"
        :percent="
          textData | dataFormat(option.decimalNum, option.totalCustomValueSwitch, option.dataAll, option.dataTrue)
        "
        :strokeWidth="option.fontWeight"
        :strokeColor="option.progressColor"
        :width="option.width"
      >
        <template #format="percent" v-if="option.dataTrue">
          <span>{{ percent }}</span>
        </template>
      </a-progress>
    </div>
    <!-- 显示真实值 默认开-->
    <div v-else :style="backGroundColorStyle">
      <div style="margin:10px;">
        <div style="display:inline-block;text-align:left;float:left;" v-if="option.titleOption" :style="fontStyle">
          {{ option.title }}
        </div>
        <!-- <div style="display:inline-block;width:60%;"> -->

        <div style="display:inline-block;float:right;">
          <div
            v-if="option.pictureOption"
            style="
            display:inline-block;
            vertical-align:middle;
            border-radius:20px;
            width:20px;
            height:10px;
            background-color:#f5f5f5"
          ></div>
          <span :style="pictureFontsizeStyle" v-if="option.pictureOption"
            >{{ option.dataAllTitle }}：{{ optionDataAll }}{{ option.company | companyOption(option.dataTrue) }}</span
          >
        </div>
        <div style="display:inline-block;float:right;margin-right:2%;">
          <div
            v-if="option.pictureOption"
            style="
            display:inline-block;
            vertical-align:middle;
            border-radius:20px;
            width:20px;
            height:10px;"
            :style="progressColor"
          ></div>
          <span :style="pictureFontsizeStyle" v-if="option.pictureOption"
            >{{ option.dataTitle }}：{{ optionData }}{{ option.company | companyOption(option.dataTrue) }}</span
          >
        </div>
        <!-- dataAllFormat(option.decimalNum) -->
        <!-- </div> -->
      </div>
      <a-progress
        style="margin-top:10px;"
        :showInfo="false"
        :percent="
          textData | dataFormat(option.decimalNum, option.totalCustomValueSwitch, option.dataAll, option.dataTrue)
        "
        :strokeWidth="option.fontWeight"
        :strokeColor="option.progressColor"
        :width="option.width"
      >
        <template #format="percent" v-if="option.dataTrue">
          <span>{{ percent }}</span>
        </template>
      </a-progress>
    </div>
  </div>
</template>

<script>
export default {
  // 导航配置组件
  name: 'CircularProgressBar',
  components: {},
  props: {
    option: {
      type: Object,
      default: () => {}
    },
    position: {
      type: Object,
      default: () => {}
    }
    // viewType: {
    //   type: String,
    //   default: ''
    // }
  },
  data() {
    return {}
  },
  filters: {
    dataFormat(textData, decimalNum, totalCustomValueSwitch, dataAll) {
      // console.log('123', textData, decimalNum, totalCustomValueSwitch, dataAll)
      let fixedData = 0
      fixedData = parseFloat(textData.toFixed(decimalNum)) // 保留几位小数后的值
      // 自定义总值开关开启
      if (totalCustomValueSwitch) {
        // 占比
        let proportion = 1
        proportion = (fixedData / dataAll) * 100
        parseFloat(proportion.toFixed(decimalNum))
        return parseFloat(proportion.toFixed(decimalNum))
      } else {
        // 自定义总值开关 关闭
        return fixedData
      }
    },
    // 单位开关
    companyOption(company, dataTrue) {
      if (dataTrue) {
        company = ''
      } else {
        return company
      }
      console.log('company,dataTrue: ', company, dataTrue)
    },
    // 保留小数位数
    dataFormatOption(textData, decimalNum) {
      let fixedData = 0
      fixedData = parseFloat(textData.toFixed(decimalNum)) // 保留几位小数后的值
      return fixedData
    }
  },
  computed: {
    fontStyle() {
      const fontstyle = {
        'font-size': `${this.option.fontSize}px`, // 字体大小
        color: this.option.color // 字体颜色
        // 'background-color': this.option.backGroundColorProgress // 进度条背景颜色
      }
      return fontstyle
    },
    // 图例字体大小
    pictureFontsizeStyle() {
      const fontstyle = {
        'font-size': `${this.option.pictureFontsize}px`, // 字体大小
        color: this.option.pictureColor // 字体颜色
        // 'background-color': this.option.backGroundColorProgress // 进度条背景颜色
      }
      return fontstyle
    },
    // 背景颜色
    backGroundColorStyle() {
      const fontstyle = {
        'background-color': this.option.backgroundColor, // 背景颜色
        'text-align': this.option.textAlign
      }
      return fontstyle
    },
    // 图例颜色
    progressColor() {
      const fontstyle = {
        'background-color': this.option.progressColor
      }
      return fontstyle
    },
    textData() {
      const data = this.option.data
      // if (this.option.unit) data = Math.round(data / 10000)
      // if (this.option.thousands) { data = data.toString().replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,') }
      // if (this.option.unit) data += '万'
      return parseFloat(data)
    },
    optionData() {
      const data = this.option.data
      return Number(data).toFixed(Number(this.option.decimalNum))
    },
    optionDataAll() {
      const data = this.option.dataAll
      return Number(data).toFixed(Number(this.option.decimalNum))
    }
  }
}
</script>

<style scoped lang="less"></style>
